import { Component, OnInit, ChangeDetectorRef, EventEmitter, Input, Output } from "@angular/core";
import { Page } from "Classes/Page";
import { CookieManagementService as CookieService } from "Services/cookie-management.service";
import { AuthenticationService } from "Services/authentication.service";
import { FetchDataService } from "Services/fetch-data.service";
import { EventService } from "Services/event.service";
declare var $: any;

@Component({
    selector: "landing-page",
    template: require('./landing-page.component.html'),
    styles: [require('./landing-page.component.css'), require('./landing-page.component.theme-2.css')]
})

export class LandingPageComponent implements OnInit {
    constructor(
        private fetchDataService: FetchDataService,
        private authenticationService: AuthenticationService,
        private cookieService: CookieService,
        private changeDetectorRef: ChangeDetectorRef,
        private eventService: EventService
    ) {
    }

    //Hostname
    hostnameArray: string[] = window.location.hostname.split('.');
    hostName: string = this.hostnameArray[this.hostnameArray.length - 2];

    accountInfoTxt: string;
    permissionsManagementText: string = "Manage Permissions";
    userManagementTxt: string = "Create User";
    homeTxt: string = "Home";
    somewhereElseTxt: string = "Somewhere Else";
    signOutTxt: string = "Sign Out";
    body: any;

    @Input() usedSSO: boolean;
    menuHeader = "Menu";
    userHeader = "Welcome";
    bigEnough: boolean = true;
    userOpened: string = 'inactive';
    menuOpened: string = 'inactive';
    headerText: string = "RSL Portal";
    subheaderText: string = "Applications";
    _permissions: number;
    _access: string[];
    message: string;
    userFirstName: string = "";
    firstName: boolean = false;
    authData: any;
    accountInfoImg: string = "assets/accountInfo.svg";
    links: any[] = [];
    menuLinks: any[] = [
        {
            text: this.homeTxt,
            link: this.fetchDataService.myUrl,
            _this: this,
            img: "./assets/home.svg",
            permission: this.fetchDataService.guest
        },
        {
            text: this.somewhereElseTxt,
            link: this.fetchDataService.teamDispatchingUrl,
            _this: this,
            img: "./assets/somewhereElse.svg",
            permission: this.fetchDataService.admin
        }
    ];
    userLinks: any[] = [
        ////{
        ////    text: this.accountInfoTxt,
        ////    subtext: "",
        ////    img: "",
        ////    _this: this,
        ////    permission: this.fetchDataService.guest
        //{
        //    text: this.userManagementTxt,
        //    _this: this,
        //    img: "./assets/administratorSettings.svg",
        //    //permission: this.fetchDataService.smcSuperAdmin
        //    permission: this.fetchDataService.getAuthData().user === "KruseAW"
        //},
        {
            text: this.permissionsManagementText,
            _this: this,
            img: "./assets/administratorSettings.svg",
            permission: this.fetchDataService.smcSuperAdmin
        },
        {
            text: this.signOutTxt,
            _this: this,
            img: "./assets/signOut.svg",
            permission: this.fetchDataService.regular
        }
    ];

    allLinks: any[] = [
        this.userLinks[0],
        this.menuLinks[0],
        this.userLinks[1],
        this.menuLinks[1],
        //this.userLinks[2]
    ];

    pages: Page[] = [];
    widthUntilCollapse: number = 600;
    ngOnInit(): void
    {
        //this.usedSSOChange.emit(this.usedSSO);
        this.authenticationService.setSSOCookie(this.usedSSO);
        this.links = this.menuLinks;
        this.pages = this.fetchDataService.getAccessibleApps();
        this.authData = this.fetchDataService.getAuthData();
        this.assignPicturesToPages(this.pages);
        if (this.authData && this.authData.firstName) {
            this.firstName = true;
            //this.userFirstName = ", " + (authData.firstName.charAt(0).toUpperCase() + authData.firstName.slice(1));
            this.accountInfoTxt = this.upperCase(this.authData.firstName) + " " + this.upperCase(this.authData.lastName);
            
            //this.userLinks[0].text = this.accountInfoTxt;
            //this.userLinks[0].subtext = this.authData.email;
        }
        if (window.innerWidth < this.widthUntilCollapse) {
            this.links = this.allLinks;
            this.bigEnough = false;
        }
        if (this.fetchDataService.smcSuperAdmin) {
            this.fetchDataService.fetchUsers();
        }
        this._permissions = this.fetchDataService.getPermissions();
        this.message = "Hello World!";

        let ref = this;
        this.changeDetectorRef.detectChanges();

    }

    assignPicturesToPages(pages: any): void {
        for (let page of pages) {
            let link = "assets/";
            switch (page.name.replace(/ /g, '').toLowerCase()) {
                case "rams": page.img = link + "RamsImg.png"; break;
                case "cmc": page.img = link + "somewhereElse.svg"; break;
                case "smc": page.img = link + "SMC.png"; break;
                case "smc2020": page.img = link + "SMC.png"; break;
                case "smc2021": page.img = link + "SMC.png"; break;
                case "smc2022": page.img = link + "SMC.png"; break;
                case "smc2023": page.img = link + "SMC.png"; break;
                case "smc2024": page.img = link + "SMC.png"; break;
                case "smc2025": page.img = link + "SMC.png"; break;
                case "smclegacy": page.img = link + "SMC.png"; break;
                case "amsreachback": page.img = link + "AMS.png"; break;
                case "apppage": page.img = link + "rslapppage.png"; break;
                case "ecamstatus": page.img = link + "ecam.jpg"; break;
                case "gisportal": page.img = link + "gis.png"; break;
            }
        }
    }

    goToPage(uri: string, type: string): void {

        this.eventService.broadcast(this.eventService._goToPage, uri, type);

        //var expireDate = new Date((new Date()).getTime() + this.fetchDataService.expireMinutes * 60 * 1000);

        //uri = uri.replace("apge", "page");
        //this.cookieService.put("UserGuid", this.fetchDataService._userGuid, expireDate);
        //this.cookieService.put("Email", this.fetchDataService.getEmail(), expireDate);
        //if (type.toLowerCase() === "smc") {

        //    //this.cookieService.put("RslAppPageLogin", this.authenticationService._userName, { 'expires': expireDate, 'domain': ".doerer.us" });
        //    //this.cookieService.put("RslAppPageFName", this.authenticationService._firstName, { 'expires': expireDate, 'domain': ".doerer.us" });
        //    //this.cookieService.put("RslAppPageLName", this.authenticationService._lastName, { 'expires': expireDate, 'domain': ".doerer.us" });
        //    //this.cookieService.put("RslAppPageToken", this.authenticationService.getRawToken("smc"), { 'expires': expireDate, 'domain': ".doerer.us" });
        //    this.cookieService.put("RslAppPageUserId", this.authenticationService._userId, expireDate);
        //    this.cookieService.put("RslAppPageLogin", this.authenticationService._userName, expireDate);
        //    this.cookieService.put("RslAppPageFName", this.authenticationService._firstName, expireDate);
        //    this.cookieService.put("RslAppPageLName", this.authenticationService._lastName, expireDate);
        //} else if (type.toLowerCase() === "rams" || type.toLowerCase() === "cm") {
        //    this.cookieService.put("RamsFName", this.authenticationService._firstName, expireDate);
        //    this.cookieService.put("RamsLName", this.authenticationService._lastName, expireDate);
        //    this.cookieService.put("RamsLogin", this.authenticationService._ramsUserName, expireDate);

        //} else if (type.toLowerCase() === "ams") {
            
        //}

        //// Hello there
        //window.location.assign(uri);
    }

    upperCase(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    registerSSO(): void
    {
        this.authenticationService.registerSSO();
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Components/landing-page.component.ts